import { timeTicker } from '@/utils/helpers/relativeTime';

// Consumables A/B: true for 24 hours after the primary ad's boost ended.
// Reads the ticking clock, so the window closes without a new read.
function inReboostWindow(state) {
  return (
    state.reboostClosesAt !== null && state.reboostClosesAt > timeTicker.now
  );
}

export default { inReboostWindow };
